import styled from 'styled-components';
import { ButtonGroup } from '@m/alchemy-ui/ButtonGroup';
import { color, units, typeStyle } from '@m/alchemy-ui/theme';

export const Title = styled.label`
  ${typeStyle('labelL')};
  color: ${color('contrast', { palette: 'illustrativeSteelGrey' })};
`;

export const Description = styled.p`
  ${typeStyle('bodyS')};
  color: ${color('contrast', { palette: 'illustrativeSteelGrey' })};
`;

export const DescriptionButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const NoWrapButtonGroup = styled(ButtonGroup)`
  flex-wrap: nowrap;
  margin-left: ${units(3)};
`;
